// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { ApiHandlerDiscreteParameter, HasOnSuccess, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { SubmitContactUsFormApiParameter } from "@insite/client-framework/Services/EmailService";
import {
    chain,
    PopulateApiParameter,
} from "@insite/client-framework/Store/Components/ContactUsForm/Handlers/SubmitContactForm";

type SubmitContactFormParameter = {
    emailRecipients: string;
} & HasOnSuccess;

export interface XngSubmitContactUsFormApiParameter extends SubmitContactUsFormApiParameter {
    topic?: string;
    firstName?: string;
    lastName?: string;
    phoneNumber?: string;
    emailAddress?: string;
    message?: string;
    emailTo?: string;
    properties: {
        howDidYouHearAboutUs: string;
        company: string;
    };
}

type HandlerType = ApiHandlerDiscreteParameter<SubmitContactFormParameter, XngSubmitContactUsFormApiParameter>;

export const XngPopulateApiParameter: HandlerType = (props: any) => {
    const state = props.getState().components.contactUsForm;
    props.apiParameter = {
        topic: state.fieldValues["topic"],
        firstName: state.fieldValues["firstName"],
        lastName: state.fieldValues["lastName"],
        phoneNumber: state.fieldValues["phoneNumber"],
        emailAddress: state.fieldValues["emailAddress"],
        message: state.fieldValues["message"],
        emailTo: props.parameter.emailRecipients,
        properties: {
            howDidYouHearAboutUs: state.fieldValues["resource"],
            company: state.fieldValues["companyName"],
        },
    };
};

replaceInChain(chain, PopulateApiParameter, XngPopulateApiParameter);
